import { Reducer } from "redux";

import { Types } from "@sendum/core";

import { DispatchAction } from "./SendumSupportStore";
import { SendumSupportActionTypes } from "./SendumSupportActions";

export interface ISendumSupportState {
	error?: Error;
	isInitialLoading: boolean;
	isLoading?: boolean;
	accounts: Types.Account[];
	users: Types.User[];
}

const initialState: ISendumSupportState = {
	accounts: [],
	users: [],
	isInitialLoading: false,
};

export const SendumSupportReducer: Reducer<ISendumSupportState, DispatchAction> = (state = initialState, action) => {
	switch (action.type) {
		case SendumSupportActionTypes.RESET_STATE: {
			return { ...initialState };
		}
		case SendumSupportActionTypes.END_INITIAL_LOADING: {
			return { ...state, ...{ isInitialLoading: false } };
		}
		case SendumSupportActionTypes.SET_ERROR: {
			return { ...state, error: action.payload.error };
		}
		case SendumSupportActionTypes.SET_LOADING: {
			return { ...state, isLoading: action.payload.isLoading };
		}
		case SendumSupportActionTypes.SET_ACCOUNTS: {
			return { ...state, accounts: action.payload.accounts ?? [] };
		}
		case SendumSupportActionTypes.SET_USERS: {
			return { ...state, users: action.payload.users ?? [] };
		}
		default:
			return state;
	}
};
